import React, { useEffect, useState, useCallback } from "react";
import "../../Styles/yellowcalf.css/Wallet_Sales_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function WalletAGING() {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [students, setStudents] = useState([]);
  const [agingData, setAgingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [endDate, setEndDate] = useState("2026-03-01");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        due_date: endDate || "",
      };

      const response = await simplePostCall(
        ApiConfig.InvoiceagingReport,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setStudents(response.students || []);
        setAgingData(response.excelArray || []);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  }, [endDate]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleClearFilters = () => {
    setEndDate("");
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Invoice Aging Report</h4>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <label className="yc-filter-label">Due Date:</label>
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <button className="btn btn-primary" onClick={handleClearFilters}>
            Clear
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-8">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Student</div>
            <div className="yc-list-cell">Adm No.</div>
            <div className="yc-list-cell">0-30 Days</div>
            <div className="yc-list-cell">31-60 Days</div>
            <div className="yc-list-cell">61-90 Days</div>
            <div className="yc-list-cell">90+ Days</div>
            <div className="yc-list-cell">Total Due</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : agingData.length > 0 ? (
          <div className="yc-list-row-list">
            {agingData.map((item, index) => {
              const studentInfo = students.find(
                (s) => s.student_admission_num === item.student_admission_num,
              );
              return (
                <div key={index} className="yc-list-row-card">
                  <div className="yc-list-grid yc-list-grid-8">
                    <div className="yc-list-cell">{index + 1}</div>
                    <div className="yc-list-cell">{studentInfo ? studentInfo.student_name : "---"}</div>
                    <div className="yc-list-cell">{item.student_admission_num}</div>
                    <div className="yc-list-cell">{customer_currency} {formatNumber(item.zero_to_thirtydays)}</div>
                    <div className="yc-list-cell">{customer_currency} {formatNumber(item.thirtyone_to_sixtydays)}</div>
                    <div className="yc-list-cell">{customer_currency} {formatNumber(item.sixtyone_to_ninetydays)}</div>
                    <div className="yc-list-cell yc-amount-danger">
                      {customer_currency} {formatNumber(item.nietyPlus)}
                    </div>
                    <div className="yc-list-cell yc-amount-positive">
                      {customer_currency} {formatNumber(item.totalSum)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="yc-empty-state">No aging records found.</div>
        )}
      </div>
    </div>
  );
}

export default WalletAGING;
